<script setup lang="ts">
import Page from '~/enums/page'
</script>

<template>
  <NuxtLink class="relative z-50 mx-auto md:mx-0" :to="Page.Main">
    <SvgIcon class="!h-auto !w-[77px] leading-none text-white md:!w-[86px] 2xl:!w-28" name="brands/itab-normal" />
  </NuxtLink>
</template>
